import 'intersection-observer'
import 'promise-polyfill/src/polyfill'
import { createComponent } from '@bigyouth/base'

// import lazySizes from 'lazysizes'
import 'lazysizes/plugins/rias/ls.rias.min'
import 'lazysizes/plugins/video-embed/ls.video-embed.min'
import 'lazysizes/plugins/bgset/ls.bgset.min'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'

import './polyfills'
import './assets'

import './style/styles.scss'

import './components'
import * as features from './features'

import emitter from './utils/emitter'

// Ghis stuff
import App from './utils/starter-specific/App'

window.LANG = document.querySelector('html').getAttribute('lang')

window.isIE11 = !!window.MSInputMethodContext && !!document.documentMode
// true on IE11
// false on Edge and other IEs/browsers.

export const YOUTUBE_API = {
  IS_READY: 'YOUTUBE_IS_READY',
}

export const FONT_ACTIONS = {
  FONT_LOADED: 'IS_LOADED',
}

// load youtube API
var tag = document.createElement('script')

tag.src = 'https://www.youtube.com/iframe_api'
var firstScriptTag = document.getElementsByTagName('script')[0]
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)

window.onYouTubeIframeAPIReady = () => {
  emitter.trigger(YOUTUBE_API.IS_READY)
}

const app = new App('#app')
// const trackingEnable = true

Object.values(features).forEach(createComponent)

app.onReady(() => {
  console.log('the app is ready ... ok')
})
